import { WrappedServiceRequest } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/ServiceRequest';
import CollapsibleCard from 'src/careflow/common/CollapsibleCard';
import useValueSetsByIdentifiers from 'src/hooks/useValueSetsByIdentifier';
import { IdentifierDetails } from '../../../../careflow/care-coordination/patient/identifier-detail/IdentifierDetails';
import { Identifier } from 'src/careflow/ph-core/fhir-client/resources';
import useLocales from 'src/careflow/ph-core/internationalization/hook/useLocales';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { LoadingComponent } from '../../case/detail/components/RelatedReferrals/components';
export interface ReferralIdentifiersProps {
  isOpen: boolean;
  serviceRequest: WrappedServiceRequest | null;
  onUpdateIdentifiers: (newIdentifiers: Identifier[]) => void;
}

const ReferralIdentifiers = ({
  isOpen,
  serviceRequest,
  onUpdateIdentifiers,
}: ReferralIdentifiersProps) => {
  const {
    valueSets: [serviceRequestIdentifiers],
    isLoading: isLoadingServiceRequestIdentifiers,
  } = useValueSetsByIdentifiers(['ph-serviceRequest-identifier-types']);
  const { i18n } = useLocales();

  const isLoading = isLoadingServiceRequestIdentifiers || !serviceRequest?.id;

  return (
    <CollapsibleCard
      title={i18n('referral.details.identifiers.title', 'crs')}
      titleSx={{ ml: 1 }}
      isOpenExternal={isOpen}
      margin={2}
    >
      {!isLoading ? (
        <IdentifierDetails
          sxContainer={{ height: 260 }}
          identifiers={serviceRequest?.identifier ?? []}
          catalog={serviceRequestIdentifiers?.asList?.() ?? []}
          systemVS={serviceRequestIdentifiers?.getConceptSystem()}
          onUpdateIdentifiers={onUpdateIdentifiers}
          permissions={{
            isAllowedToAdd: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.ADD],
            }),
            isAllowedToEdit: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.EDIT],
            }),
            isAllowedToDelete: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.DELETE],
            }),
            isAllowedToViewHidden: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.HIDDEN.VIEW],
            }),
            isAllowedToEditHidden: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.HIDDEN.EDIT],
            }),
            isAllowedToDeleteHidden: checkAclValidation({
              acls: [crsAcls.CRS.REFERRAL.IDENTIFIER_DETAILS.HIDDEN.DELETE],
            })
          }}
        />
      ) : (
        <LoadingComponent />
      )}
    </CollapsibleCard>
  );
};

export default ReferralIdentifiers;
